import React from 'react';
import { NavLink, Link, useNavigate, useParams } from "react-router-dom";
import { ErrorBoundary, Loaders } from "./../components";
import { 
  useCompaniesList,
} from "./../queries/company";
import usePagination from "./../hooks/usePagination";


let CompanyContext;
const { Provider } = (CompanyContext = React.createContext());

const CompanyContextProvider = ({ children }) => {
  const navigate = useNavigate();
  let { company_id } = useParams();
  const [selectedCompany, selectCompany] = React.useState(null);
  const pageConfig = usePagination();
  const companiesList = useCompaniesList(pageConfig.current)

  const companies = React.useMemo(() => {
    if(companiesList.isSuccess)
      return companiesList.data.data
    return []
  }, [companiesList])

  React.useEffect(() => {
    let currentCompany;
    if(companies.length > 0) {
      if(company_id === undefined) {
        currentCompany = companies[0]
        selectCompany(currentCompany)
        navigate(`companies/${currentCompany.slug}`)
      }
      else {
        currentCompany = companies.find(c => c.id === company_id || c.slug === company_id)
        selectCompany(currentCompany)
      }
    }
  }, [companies, selectCompany, company_id])

  if (companiesList.isLoading || !selectedCompany){
    return (
      <ErrorBoundary>
        <Loaders.SpacedPageLoader />
      </ErrorBoundary>
    )
  }

  if (companiesList.isError){
    return (
      <ErrorBoundary>
        Error
      </ErrorBoundary>
    )
  }

  return (
    <Provider value={{ companies, selectedCompany, selectCompany }}>
      {children}
    </Provider>
  );
};

export { CompanyContext, CompanyContextProvider };
